import { getAllGraphStepChildrenIds } from '../../graph/getAllGraphStepChildrenIds.js';

export const validateFolder = ({ step, workflow }) => {
  const steps = workflow?.steps;
  const graph = workflow?.graph;
  const graphStep = graph[step?.id];
  const allChildrenIds = getAllGraphStepChildrenIds(graph, graphStep.child, [graphStep.child]);
  const allChildrenSteps = steps.filter((s) => allChildrenIds.includes(s?.id));

  const isValid = allChildrenSteps.every((s) => s.isValid);
  if (!isValid) {
    return { status: 'invalid', message: 'Fix folder steps' };
  }

  return { status: 'valid' };
};
